import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M21.85 43.35 4.65 26.15Q3.85 25.35 3.85 24Q3.85 22.65 4.65 21.85L21.85 4.65Q22.65 3.85 24 3.85Q25.35 3.85 26.15 4.65L43.35 21.85Q44.15 22.65 44.15 24Q44.15 25.35 43.35 26.15L26.15 43.35Q25.35 44.15 24 44.15Q22.65 44.15 21.85 43.35ZM24 41.2Q24 41.2 24 41.2Q24 41.2 24 41.2L41.2 24Q41.2 24 41.2 24Q41.2 24 41.2 24L24 6.8Q24 6.8 24 6.8Q24 6.8 24 6.8L6.8 24Q6.8 24 6.8 24Q6.8 24 6.8 24ZM24 33.85 33.85 24 24 14.15 21.85 16.3 28.05 22.5H14.15V25.5H28.05L21.85 31.7ZM24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { toRefs } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    size: { default: 12 }
  },
  setup(__props: any) {

const props = __props as { size: number }

    

    const { size } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _unref(size),
    height: _unref(size),
    viewBox: "0 0 48 48",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})